module.exports = __webpack_public_path__ + "static/media/fugro-logo-wh.0f542cf7.png";